import * as React from 'react'
import './History.scss'
import {ActionType, reducerStoreType, RecordsListType} from "../../reducers/types";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import {StyledTableCell} from "../../components/CustomUIComp/CustomTable";
import TableBody from "@material-ui/core/TableBody";
import noDataIcon from '../../images/null_icon.svg';
import {injectIntl, IntlShape} from 'react-intl'
import {connect} from "react-redux";
import {Dispatch} from "redux";

interface IProps {
    dispatch: Dispatch<ActionType<any>>,
    list: RecordsListType[],
    intl: IntlShape
}

class History extends React.Component<IProps> {
    
    public render() {
        let {list, intl} = this.props
        return (
            <div className="History">
                <div className="header">
                    <h2>{intl.formatMessage({id: 'exchangeRecords'})}</h2>
                </div>
                <div className="orderList">
                    <Table>
                        <TableHead>
                            <TableRow>
								<StyledTableCell align='center'>{intl.formatMessage({id: 'transactionStatus'})}</StyledTableCell>
                                <StyledTableCell align='center'>{intl.formatMessage({id: 'currentCurrency'})}</StyledTableCell>
                                <StyledTableCell align='center'>{intl.formatMessage({id: 'salesAmount'})}</StyledTableCell>
                                <StyledTableCell align='center'>{intl.formatMessage({id: 'buyingCurrency'})}</StyledTableCell>
								<StyledTableCell align='center'>{intl.formatMessage({id: 'exchangeRate'})}</StyledTableCell>
								<StyledTableCell align='center'>{intl.formatMessage({id: 'purchaseAmount'})}</StyledTableCell>
								<StyledTableCell align='center'>{intl.formatMessage({id: 'createTime'})}</StyledTableCell>
								<StyledTableCell align='center'>{intl.formatMessage({id: 'successTime'})}</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {list.map((item, i) => {
                                return (<TableRow hover key={`${item.id}-${i}`}>
									<StyledTableCell align='center'>
									    {item.status === 0 ? 
											<span>
											   {intl.formatMessage({id: 'untreated'})}
											</span> : 
											<span>
											   {intl.formatMessage({id: 'exchangeSucc'})}
											</span>
										}
									</StyledTableCell>
                                    <StyledTableCell align='center'>
                                        <span>
                                           {item.sellCurrency}
                                        </span>
                                    </StyledTableCell>
                                    <StyledTableCell align='center'>
                                        {item.sellAmt}
                                    </StyledTableCell>
                                    <StyledTableCell align='center'>
                                        {item.buyCurrency}
                                    </StyledTableCell>
									<StyledTableCell align='center'>
										{item.exchangeRate}
									</StyledTableCell>
									<StyledTableCell align='center'>
										{item.buyAmt}
									</StyledTableCell>
									<StyledTableCell align='center'>
										{item.createTime}
									</StyledTableCell>
									<StyledTableCell align='center'>
										{item.successTime}
									</StyledTableCell>
                                </TableRow>)
                            })}
                        </TableBody>
                    </Table>
                    {list.length === 0 ?
                        <div className="noData">
                            <img src={noDataIcon} alt="no data"/>
                            <p>{intl.formatMessage({id: 'noData'})}</p>
                        </div>
                        : null}
                </div>
            </div>
        );
    }
}
export default injectIntl(connect((state: reducerStoreType) => {
    return {
        list: state.exchangeRecords.RecordsInfo.list
    }
})(History))